<div
	class="dropdown-host text-content"
	(click)="openDialog()"
	(mouseenter)="isHovered.set(true)"
	(mouseleave)="isHovered.set(false)"
	[class.active]="showDropdown()"
	[attr.aria-label]="label()"
	#dropdownHost
>
	<div class="content">{{ huidigeWaarde() }}</div>
	<app-icon [name]="iconName()" size="small" [color]="iconColor()"></app-icon>
</div>
